export default __webpack_public_path__ + "assets/img/line-awesome.58df7918b614b748dd5715159ffc8c65.woff";